import { render, staticRenderFns } from "./ReferenceLink.vue?vue&type=template&id=7145fc76&scoped=true&"
import script from "./ReferenceLink.vue?vue&type=script&lang=js&"
export * from "./ReferenceLink.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceLink.vue?vue&type=style&index=0&id=7145fc76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145fc76",
  null
  
)

export default component.exports